export default __webpack_public_path__ + "static/8-d5ba99b539f935e6e39cfb86142d69bd.png";